export function getDeviceMemory() {
  try {
    if ('deviceMemory' in navigator) {
      const value = Number.parseFloat(String(navigator.deviceMemory))

      if (Number.isNaN(value)) {
        return
      }

      return value
    }
  } catch {
    return
  }
}

export function getDeviceHC() {
  try {
    if ('hardwareConcurrency' in navigator) {
      const value = Number.parseFloat(String(navigator.hardwareConcurrency))

      if (Number.isNaN(value)) {
        return
      }

      return value
    }
  } catch {
    return
  }
}

export function getDeviceTier(deviceMemory?: number, deviceHC?: number) {
  if (deviceMemory) {
    if (deviceMemory <= 2) {
      return 'low-end'
    }

    if (deviceMemory <= 3) {
      return 'middle-end'
    }
  }

  if (deviceHC) {
    if (deviceHC <= 2) {
      return 'low-end'
    }

    if (deviceHC <= 4) {
      return 'middle-end'
    }

    if (deviceHC > 4) {
      return 'high-end'
    }
  }

  return 'unknown'
}
